/**
 * A class that acts as a container of a range of validator classes that
 * returns a list of errors if not valid
 *
 */
export default class Validation {
    constructor() {
        /**
         *
         * @type {BaseValidator[]}
         * @private
         */
        this._validators = [];
    }

    /**
     *
     * @param {BaseValidator} validator
     * @return {Validation}
     */
    addValidator(validator) {
        this._validators.push(validator);
        return this;
    }

    /**
     * Returns array of error messages. If there are no messages, then it's valid
     *
     * @param value
     * @param isRequired set to true if the value must be defined and not falsy
     * @param t - translation function (optional)
     * @return {String[]}
     */
    validate(value, isRequired = false, t = null) {
        let errors = [];
        let hasValue = !(value == null || value === "");

        if (isRequired && !hasValue) {
            let errorText = t ? t("validation.required") : null;
            errorText = errorText || "A value must be defined";
            if (errorText) {
                errors.push(errorText);
            }
        } else if (hasValue) {
            for (let v of this._validators) {
                errors = errors.concat(v.validate(value, t));
            }
        }

        return errors;
    }

    /**
     * Returns a boolean equivilent of validate()
     *
     * @param value
     * @param isRequired
     * @param t - translation function (optional)
     * @returns {boolean}
     */
    isValid(value, isRequired = false, t = null) {
        let errors = this.validate(value, isRequired, t);
        return errors.length === 0;
    }
}
